import { useState, useEffect } from 'react'
import { useDebounce } from '../../hooks/useDebounce'

export default function CidadeAutocomplete({ 
  value, 
  onChange, 
  onEstadoChange,
  placeholder = "Digite a cidade...",
  className = "input-rematei"
}) {
  const [inputValue, setInputValue] = useState(value || '')
  
  // Sincronizar com prop value quando mudar
  useEffect(() => {
    setInputValue(value || '')
  }, [value])
  const [suggestions, setSuggestions] = useState([])
  const [showSuggestions, setShowSuggestions] = useState(false)
  const [loading, setLoading] = useState(false)
  
  const debouncedSearch = useDebounce(inputValue, 300)

  useEffect(() => {
    if (debouncedSearch && debouncedSearch.length >= 2) {
      searchCidades(debouncedSearch)
    } else {
      setSuggestions([])
      setShowSuggestions(false)
    }
  }, [debouncedSearch])

  const searchCidades = async (query) => {
    try {
      setLoading(true)
      
      // Buscar por todos os estados brasileiros
      const estados = ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO']
      
      const promises = estados.map(uf => 
        fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/municipios`)
          .then(res => res.json())
          .then(cidades => 
            cidades
              .filter(cidade => cidade.nome.toLowerCase().includes(query.toLowerCase()))
              .map(cidade => ({
                id: cidade.id,
                nome: cidade.nome,
                uf: uf,
                display: `${cidade.nome} - ${uf}`
              }))
          )
          .catch(() => [])
      )
      
      const results = await Promise.all(promises)
      const allCidades = results.flat().slice(0, 15)
      
      // Ordenar por nome
      allCidades.sort((a, b) => a.nome.localeCompare(b.nome))
      
      setSuggestions(allCidades)
      setShowSuggestions(allCidades.length > 0)
    } catch (error) {
      console.error('Erro ao buscar cidades:', error)
      setSuggestions([])
      setShowSuggestions(false)
    } finally {
      setLoading(false)
    }
  }

  const handleInputChange = (e) => {
    const newValue = e.target.value
    setInputValue(newValue)
    onChange(newValue)
  }

  const handleSelectCity = (cidade) => {
    const cityName = cidade.nome
    console.log('Selecionando cidade:', cityName, 'UF:', cidade.uf)
    setInputValue(cityName)
    onChange(cityName)
    onEstadoChange?.(cidade.uf)
    setShowSuggestions(false)
  }

  return (
    <div className="relative">
      <input
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        onBlur={() => setTimeout(() => setShowSuggestions(false), 300)}
        className={className}
        placeholder={placeholder}
        autoComplete="off"
      />
      
      {loading && (
        <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
        </div>
      )}
      
      {showSuggestions && suggestions.length > 0 && (
        <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-y-auto">
          {suggestions.map((cidade) => (
            <div
              key={cidade.id}
              className="p-3 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0"
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => handleSelectCity(cidade)}
            >
              <div className="font-medium text-gray-900">{cidade.nome}</div>
              <div className="text-sm text-gray-500">{cidade.uf}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}